import { disabledRowClassName } from '@goodfynd/styles';
import { styled } from '@goodfynd/theme';

export const StyledBody = styled('div', {
  fontSize: 16,
  display: 'block',
  height: '100%',
  minHeight: 500,
  [`& .${disabledRowClassName}`]: {
    background: '$Neutral01',
    '& img': {
      opacity: 0.5,
    },
    '& p': {
      color: '$Neutral06',
    },
  },
});
